// Minimal pub/sub so systems can react to each other without tight coupling.
// Common events:
//   'inventory:changed'               — any add/remove to the inventory
//   'inventory:added'   ({id, count}) — a specific item was added
//   'pickup:collected'  (entry)       — a world pickup was taken
//   'flag:set'          (name)        — a story flag was set

class EventBus {
  constructor() { this.listeners = new Map(); }

  on(event, fn) {
    let set = this.listeners.get(event);
    if (!set) { set = new Set(); this.listeners.set(event, set); }
    set.add(fn);
    return () => set.delete(fn);   // unsubscribe
  }

  emit(event, payload) {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const fn of set) fn(payload);
  }
}

export const events = new EventBus();
